module.exports = __webpack_public_path__ + "media/images/event-hero-img-d12da42c7dc1903383c6daa803749a09.jpg";